import { message } from 'antd';
import Transaction from './Transaction'
import { connect } from 'react-redux'
import { reduxForm, submit, change, initialize, getFormValues } from 'redux-form'
import { push } from 'react-router-redux'
import moment from 'moment'
import { updateTransaction, onSelectPurpose, getTransaction, deleteTransaction } from './actions'
import {defaultExpenseCategories} from '../core/CategoryPicker/categories'
import {getPurposes} from './reducer'
import onMount from '../core/onMount'
import { validate } from './'

const mapStateToProps = (state, ownProps) => {
  const transactionForm = getFormValues('transaction')(state)
  const transaction = transactionForm && state.models.transactions.find(txn=>txn.token_id==transactionForm.token_id)

  return {
    isFetching: state.transactions.isFetching,
    title: transactionForm && (transactionForm.amount<0 ? `Update Expense` : `Update Revenue`),
    buttonTitle: 'Save',
    ...transactionForm,// for plaid bank props
    purposes: getPurposes(state),
    merchants: transactionForm && transactionForm.amount<0 ? ['hasMerchant'] : null,
    isExpense:  transactionForm && transaction && transaction.amount<0,
    date: transactionForm && transactionForm.date || transactionForm && transactionForm.date_formatted,
    categorySelectValue: transactionForm && transactionForm.category
      || transactionForm && transactionForm.plaid_category,
    purposeSelectValue: (transactionForm && transactionForm.income_source)
      || (transactionForm && transactionForm.purpose) || 'Work',

    categories: [
      ...defaultExpenseCategories
    ],
    photo: transactionForm && transactionForm.photo
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onDateChange: (date)=> date && date.isValid() && dispatch(change('transaction', 'date', moment(date).format('MMM DD, YYYY'))),
    save: ()=> dispatch(submit('transaction')),
    onSelectPurpose: (purpose)=> dispatch(onSelectPurpose(purpose)),
    onSelectCategory: (category)=> {
      if (category.trim()=='') return
      dispatch(change('transaction', 'category', category))
    },
    onUpload: (file)=> {
      dispatch(change('transaction', 'photo_attributes', file))
      dispatch(change('transaction', 'photo', null))
    },
    onDelete: ()=>dispatch( deleteTransaction(ownProps.match.params.transactionId) )
      .then(()=>message.success('Deleted transaction successfully.', 10))
      .then(()=> dispatch(push(`/transactions`)) ),
    dispatch,
    ownProps
  }
}
const Update = reduxForm({
  form: 'transaction',
  validate,
  onSubmit: (values, dispatch)=> dispatch(updateTransaction(values))
    // .then(()=>message.success('Updated transaction successfully.', 10))
    // .then(()=> dispatch(push(`/transactions`)) ),

})(Transaction)

const MountedUpdate = onMount(({dispatch, ownProps}) => {
  dispatch(getTransaction(ownProps.match.params.transactionId))
    .then(transaction=> dispatch(initialize('transaction', {
      ...transaction,
      merchant: transaction.merchant || transaction.plaid_name
    })))
} )(Update)

export default connect(mapStateToProps, mapDispatchToProps)(MountedUpdate)



// WEBPACK FOOTER //
// ./src/transactions/Update.js